/* Novbox product compare — v3 (prominent bar) */
(function () {
  var KEY = 'nvx_compare';
  var MAX = 4;

  /* ---------- store: array of {h, img, t} ---------- */
  function raw() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function get() {
    return raw().map(function (x) { return typeof x === 'string' ? { h: x, img: '', t: '' } : x; })
                .filter(function (x) { return x && x.h; });
  }
  function handles() { return get().map(function (x) { return x.h; }); }
  function save(a) { localStorage.setItem(KEY, JSON.stringify(a.slice(0, MAX))); render(); }
  function has(h) { return handles().indexOf(h) !== -1; }

  function toggle(h, img, t) {
    var a = get(), i = handles().indexOf(h);
    if (i === -1) {
      if (a.length >= MAX) { flash('You can compare up to ' + MAX + ' products.'); return false; }
      a.push({ h: h, img: img || '', t: t || '' });
    } else { a.splice(i, 1); }
    save(a); return true;
  }

  function flash(msg) {
    var n = document.createElement('div');
    n.className = 'nvx-toast';
    n.textContent = msg;
    document.body.appendChild(n);
    setTimeout(function () { n.classList.add('go'); }, 10);
    setTimeout(function () { n.remove(); }, 2600);
  }

  /* ---------- the bar ---------- */
  function render() {
    var a = get();
    var bar = document.getElementById('nvx-compare-bar');
    if (!bar) {
      bar = document.createElement('div');
      bar.id = 'nvx-compare-bar';
      document.body.appendChild(bar);
    }
    if (!a.length) { bar.classList.remove('is-on'); bar.innerHTML = ''; document.body.classList.remove('nvx-has-bar'); return; }
    document.body.classList.add('nvx-has-bar');

    var slots = '';
    for (var i = 0; i < MAX; i++) {
      var p = a[i];
      if (p) {
        slots += '<span class="nvx-slot filled" title="' + (p.t || '').replace(/"/g, '') + '">' +
          (p.img ? '<img src="' + p.img + '" alt="">' : '<em>' + (p.t || '?').slice(0, 2) + '</em>') +
          '<button type="button" class="nvx-slot-x" data-h="' + p.h + '" aria-label="Remove">&times;</button></span>';
      } else {
        slots += '<span class="nvx-slot"></span>';
      }
    }

    var ready = a.length >= 2;
    bar.innerHTML =
      '<div class="nvx-bar-in">' +
        '<div class="nvx-slots">' + slots + '</div>' +
        '<div class="nvx-bar-txt">' +
          '<strong>' + a.length + ' of ' + MAX + ' selected</strong>' +
          '<span>' + (ready ? 'Ready to compare' : 'Pick at least one more') + '</span>' +
        '</div>' +
        '<a class="nvx-cmp-go' + (ready ? '' : ' off') + '" href="/pages/compare?ids=' + handles().join(',') + '">' +
          'Compare ' + (ready ? a.length + ' products' : '') + ' <span aria-hidden="true">&rarr;</span></a>' +
        '<button type="button" class="nvx-cmp-clear" aria-label="Clear all">&times;</button>' +
      '</div>';

    bar.querySelector('.nvx-cmp-clear').onclick = function () { save([]); sync(); };
    bar.querySelectorAll('.nvx-slot-x').forEach(function (b) {
      b.onclick = function () { toggle(b.getAttribute('data-h')); sync(); };
    });
    if (!ready) {
      bar.querySelector('.nvx-cmp-go').addEventListener('click', function (e) {
        e.preventDefault(); flash('Select at least 2 products to compare.');
      });
    }
    requestAnimationFrame(function () { bar.classList.add('is-on'); });
  }

  /* ---------- checkboxes ---------- */
  function handleFromHref(href) {
    if (!href) return null;
    var m = href.match(/\/products\/([a-z0-9\-_%]+)/i);
    return m ? m[1].split('?')[0] : null;
  }

  function cardFor(a) {
    var c = a.closest('product-card, .gitem, .grid-content, .product-item, .card-product, .product-card, .grid__item, li.grid__item, [data-product-card]');
    if (c) return c;
    var n = a.parentElement, hops = 0;
    while (n && hops < 6) { if (n.querySelector && (n.querySelector('img') || n.children.length > 1)) return n; n = n.parentElement; hops++; }
    return null;
  }

  function inject() {
    if (document.getElementById('nvx-ct-root')) return;
    document.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      var h = handleFromHref(a.getAttribute('href'));
      if (!h) return;
      if (document.querySelector('.nvx-cmp[data-h="' + h + '"]')) return;
      var pageH = (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1];
      if (pageH && h === pageH) return;
      if (a.closest('.product-meta__wrapper, .nvx-acc, .nvx-avail, .nvx-avail-modal, .rte, .related-models, .nvs')) return;
      var card = cardFor(a);
      if (!card) return;
      if (card.closest('.nvx-ct-wrap, .nvx-ct, #nvx-compare-bar, header, nav, footer')) return;
      if (card.querySelector('.nvx-cmp')) return;
      addBox(card, h);
    });
  }

  function addBox(card, handle) {
    if (window.getComputedStyle(card).position === 'static') card.style.position = 'relative';
    var img = card.querySelector('img');
    var titleEl = card.querySelector('.product-title, .card__heading, h3, h2, a[href*="/products/"]');
    var lab = document.createElement('label');
    lab.className = 'nvx-cmp';
    lab.setAttribute('data-h', handle);
    lab.innerHTML = '<input type="checkbox"' + (has(handle) ? ' checked' : '') + '><span>Compare</span>';
    lab.querySelector('input').addEventListener('change', function (e) {
      var src = img ? (img.currentSrc || img.src || '') : '';
      var t = titleEl ? titleEl.textContent.trim() : '';
      if (!toggle(handle, src, t)) e.target.checked = false;
      sync();
    });
    card.appendChild(lab);
  }

  function sync() {
    document.querySelectorAll('.nvx-cmp').forEach(function (l) {
      var h = l.getAttribute('data-h');
      var i = l.querySelector('input');
      if (h && i) i.checked = has(h);
      l.classList.toggle('on', has(h));
    });
  }

  function boot() { inject(); sync(); render(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  var t;
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var tgt = muts[i].target;
      if (tgt && tgt.id === 'nvx-compare-bar') return;
      if (tgt && tgt.closest && tgt.closest('#nvx-compare-bar')) return;
    }
    clearTimeout(t); t = setTimeout(boot, 300);
  }).observe(document.body, { childList: true, subtree: true });

  window.nvxCompare = {
    get: handles,
    set: function (arr) { save(arr.map(function (x) { return typeof x === 'string' ? { h: x, img: '', t: '' } : x; })); },
    toggle: toggle
  };
})();
